module.exports = __webpack_public_path__ + "img/3.0ecc4b33.png";